/**
 * 代理服务, 用于转发请求, 方便在浏览器环境下访问(跨域)网络资源
 */
define([], function () {
  var service = {};

  var _fetch = function (url, method, headers, data) {
    var dfd = $.Deferred();
    console.log(`url: ${url}, method: ${method}, data: ${data}`);

    // 调整url, 然后使用异步请求
    console.log(method);
    var proxyUrl = `http://localhost:3000/proxy?url=${url}`;
    $.ajax({
      url: proxyUrl,
      method: method,
      headers: headers,
      data: data,
      dataType: 'json'
    }).done(function (json) {
      dfd.resolve(json);
    }).fail(function () {
      dfd.reject();
    });

    return dfd;
  };

  service.httpGet = function (params, headers) {
    return _fetch(params.url, 'GET', headers, null);
  };

  service.httpPost = function (params, headers) {
    return _fetch(params.url, 'POST', headers, params.data);
  };

  return service;
});



/** WEBPACK FOOTER **
 ** ./src/scripts/service/proxyService.js
 **/